import { render, staticRenderFns } from "./examCoursesLoader.vue?vue&type=template&id=1fb606dc"
import script from "./examCoursesLoader.vue?vue&type=script&lang=js"
export * from "./examCoursesLoader.vue?vue&type=script&lang=js"
import style0 from "./examCoursesLoader.vue?vue&type=style&index=0&id=1fb606dc&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports